export default "__VITE_ASSET__Dp2Arqv7__"